
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productReccsImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Image"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"altText"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"blurry"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transform"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"CENTER"}},{"kind":"ObjectField","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"2"}},{"kind":"ObjectField","name":{"kind":"Name","value":"preferredContentType"},"value":{"kind":"EnumValue","value":"WEBP"}}]}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"smallMedia"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transform"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"CENTER"}},{"kind":"ObjectField","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"213"}},{"kind":"ObjectField","name":{"kind":"Name","value":"preferredContentType"},"value":{"kind":"EnumValue","value":"WEBP"}}]}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"smallMedia2x"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transform"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"CENTER"}},{"kind":"ObjectField","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"213"}},{"kind":"ObjectField","name":{"kind":"Name","value":"preferredContentType"},"value":{"kind":"EnumValue","value":"WEBP"}},{"kind":"ObjectField","name":{"kind":"Name","value":"scale"},"value":{"kind":"IntValue","value":"2"}}]}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"mediumMedia"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transform"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"CENTER"}},{"kind":"ObjectField","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"409"}},{"kind":"ObjectField","name":{"kind":"Name","value":"preferredContentType"},"value":{"kind":"EnumValue","value":"WEBP"}}]}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"mediumMedia2x"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transform"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"CENTER"}},{"kind":"ObjectField","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"409"}},{"kind":"ObjectField","name":{"kind":"Name","value":"preferredContentType"},"value":{"kind":"EnumValue","value":"WEBP"}},{"kind":"ObjectField","name":{"kind":"Name","value":"scale"},"value":{"kind":"IntValue","value":"2"}}]}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"largeMedia"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transform"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"CENTER"}},{"kind":"ObjectField","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"ObjectField","name":{"kind":"Name","value":"preferredContentType"},"value":{"kind":"EnumValue","value":"WEBP"}}]}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"largeMedia2x"},"name":{"kind":"Name","value":"url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transform"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"crop"},"value":{"kind":"EnumValue","value":"CENTER"}},{"kind":"ObjectField","name":{"kind":"Name","value":"maxWidth"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"ObjectField","name":{"kind":"Name","value":"preferredContentType"},"value":{"kind":"EnumValue","value":"WEBP"}},{"kind":"ObjectField","name":{"kind":"Name","value":"scale"},"value":{"kind":"IntValue","value":"2"}}]}}],"directives":[]}]}}],"loc":{"start":0,"end":850}};
    doc.loc.source = {"body":"fragment productReccsImage on Image {\n  id\n  altText\n  blurry: url(\n    transform: { crop: CENTER, maxWidth: 2, preferredContentType: WEBP }\n  )\n  smallMedia: url(\n    transform: { crop: CENTER, maxWidth: 213, preferredContentType: WEBP }\n  )\n  smallMedia2x: url(\n    transform: {\n      crop: CENTER\n      maxWidth: 213\n      preferredContentType: WEBP\n      scale: 2\n    }\n  )\n  mediumMedia: url(\n    transform: { crop: CENTER, maxWidth: 409, preferredContentType: WEBP }\n  )\n  mediumMedia2x: url(\n    transform: {\n      crop: CENTER\n      maxWidth: 409\n      preferredContentType: WEBP\n      scale: 2\n    }\n  )\n  largeMedia: url(\n    transform: { crop: CENTER, maxWidth: 1000, preferredContentType: WEBP }\n  )\n  largeMedia2x: url(\n    transform: {\n      crop: CENTER\n      maxWidth: 1000\n      preferredContentType: WEBP\n      scale: 2\n    }\n  )\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["productReccsImage"] = oneQuery(doc, "productReccsImage");
        
